module.exports = __webpack_public_path__ + "static/img/アセット 13@2x.1d27faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/アセット 13@2x.png
// module id = 5dn6
// module chunks = 1